import React from "react";
import PropTypes from "prop-types";
import { TimePicker } from "antd";
import { Delete } from "@mui/icons-material";
import dayjs from "dayjs";
import styled from "@emotion/styled";
import { HorizontalGap } from "../styled/gaps";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const SlotSelector = (props) => {
  // alert(JSON.stringify(props));
  const onChange = (time, timeString) => {
    props.changeHandler(time, timeString);
  };
  return (
    <Container>
      <TimePicker.RangePicker
        popupStyle={{ zIndex: 2000 }}
        use12Hours
        format={"hh:mm A"}
        showNow={false}
        minuteStep={15}
        onChange={onChange}
        value={[
          dayjs(props.slot[0], "hh:mm A"),
          dayjs(props.slot[1], "hh:mm A"),
        ]}
      />
      {props.selected ? (
        <>
          <HorizontalGap size={"5px"} />
          <Delete
            onClick={() => {
              props.deleteHandler();
            }}
          />
        </>
      ) : null}
    </Container>
  );
};

SlotSelector.propTypes = {};

export { SlotSelector };
